































import Component from 'vue-class-component';
import TabsInfoMixin from '../../devices/TabsInfoMixin';
import { Mixins } from 'vue-mixin-decorator';
import { Prop } from 'vue-property-decorator';
import { Props, Global } from '@/store';
import API from '@/modules/API';
import Utils from '@/modules/Utils';
import PropUtils from '@/modules/PropUtils';
import StreamChart from '../StreamChart.vue';
import moment from 'moment';

@Component({
  components: {
    StreamChart
  }
})
class EnergyInfo extends Mixins<TabsInfoMixin>(TabsInfoMixin) {

  @Prop() deviceStreams;
  
  @Global.State('lang') lang;

  pickedPeriod = '1weeks';
  selectedStream = 'power_consumption';
  streamsLatestValue = { power_consumption: ['Power Consumption', '', false, 'watts'], voltage: ['Voltage', '', false, 'volt'], current: ['Current', '', false, 'amps'], power_factor: ['Power Factor', '', false, '']};
  show_buttons = false;
  loading = true;

  filterEnum = {
    '1days': 'Last 24 Hours',
    '2days': 'Last 48 Hours',
    '1weeks': 'Last Week',
    '1months': 'Last Month',
    '3months': 'Last 3 Month'
  };

  periods_range = new Map();
  power_consumption_history = [];

  async created() {
    this.loading = true;
    this.setPeriodsRange();
    await this.setStreamsLatestValues();
    Object.values(this.streamsLatestValue).forEach((stream_data) => {
      if (stream_data[1]) stream_data[2] = true;
    });

    const stream = Object.entries(this.streamsLatestValue).find(([stream_name, stream_data]) => stream_data[2] === true);
    if (stream){
      this.selectedStream = this.streamsLatestValue.power_consumption[2] ? 'power_consumption' : stream[0];
      this.show_buttons = true;
    }else {
      this.selectedStream = '';
      this.show_buttons = false;
    }
    this.loading = false;
  }

  setPeriodsRange(){
    const today_timestamp = moment().unix() * 1000;
    this.periods_range.set('1days', {from: moment(today_timestamp).subtract(1, 'days').valueOf(), to: today_timestamp});
    this.periods_range.set('2days', {from: moment(today_timestamp).subtract(2, 'days').valueOf(), to: today_timestamp});
    this.periods_range.set('1weeks', {from: moment(today_timestamp).subtract(7, 'days').valueOf(), to: today_timestamp});
    this.periods_range.set('1months', {from: moment(today_timestamp).subtract(1, 'months').valueOf(), to: today_timestamp});
    this.periods_range.set('3months', {from: moment(today_timestamp).subtract(3, 'months').valueOf(), to: today_timestamp});
  }

  async setStreamsLatestValues(){
    // Latest value + last-changed time come from the reporting columns already
    // loaded into `deviceStreams` (value + last_modified). No extra /latest call.
    // History (for the chart) is still fetched per selected period.
    await this.fetchPowerConsumptionHistory();

    this.streamsLatestValue.power_consumption[1] = this.getStreamDisplayValue('power_consumption');
    this.streamsLatestValue.voltage[1] = this.getStreamDisplayValue('voltage');
    this.streamsLatestValue.current[1] = this.getStreamDisplayValue('current');
    this.streamsLatestValue.power_factor[1] = this.getStreamDisplayValue('power_factor');
  }

  async fetchPowerConsumptionHistory(){
    try {
      const start = this.periods_range.get(this.pickedPeriod).from;
      const end = this.periods_range.get(this.pickedPeriod).to;

      const url = `get_power_and_connected`;
      const body = {
        company_id: this.project.company,
        project_id: this.project.id,
        device_id: this.device.id,
        start_time: start,
        end_time: end
      };
      const response = await API.dashboardAPI(url, 'POST', {}, body);
      const formatted = response.result.map((data) => [data.timestamp, data.value]);
      this.power_consumption_history = formatted.reverse();
    
    } catch (e){
      this.power_consumption_history = [];
    }
  }

  getStreamDisplayValue(streamName) {
    const stream = PropUtils.getDeviceStream(streamName, this.deviceStreams);
    if (!stream || (!stream.value && stream.value !== 0)) return '';
    // last_modified is reporting-query epoch-seconds (with optional millis).
    const modified_ms = stream.last_modified ? Math.floor(Number(stream.last_modified) * 1000) : null;
    return modified_ms
      ? `${stream.value}, ${this.convertTimestampToString(modified_ms)}`
      : `${stream.value}`;
  }

  convertTimestampToString(timestamp){
    const date = new Date(timestamp);
    return Utils.getDateString(date);
  }

  changeStreamChart(streamName){
    this.selectedStream = streamName;
  }

  get selectedStreamName(){
    return this.selectedStream 
      ? this.streamsLatestValue[this.selectedStream][0]
      : '';
  }

  get selectedStreamUnit(){
    return this.selectedStream 
      ? this.streamsLatestValue[this.selectedStream][3]
      : '';
  }

  get periods_list(){
    return [
      { text: this.$t('Last 24 hours'), value: '1days' },
      { text: this.$t('Last 48 Hours'), value: '2days' },
      { text: this.$t('Last Week'), value: '1weeks' },
      { text: this.$t('Last Month'), value: '1months' },
      { text: this.$t('Last 3 Months'), value: '3months' }
    ];
  }
}

export default EnergyInfo;
